// src/api/widgetConfigApi.js
import axiosClient from "./axiosClient";

const widgetConfigApi = {
  GetWidgetConfig: (CusId) => {
    return axiosClient.get(`/widget_config/${CusId}`, {
      withCredentials: true,
    });
  },
  UpsertwidgetConfig: (data, wcLogo, wcBanner) => {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append("imageLogo", wcLogo);
    formData.append("imageBanner", wcBanner);
    return axiosClient.post("/widget_config/upsert", formData, {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  saveBillTemplate: (customerId, billTemplateId) => {
    return axiosClient.post(
      "/bill_templates/save-template",
      {
        customerId,
        billTemplateId,
      },
      {
        withCredentials: true,
      },
    );
  },
  UpdateBillTemplateId: (customerId, billTemplateId) => {
    return axiosClient.put(
      "/widget_config/update-bill-template-id",
      {
        customerId,
        billTemplateId,
      },
      {
        withCredentials: true,
      },
    );
  },
};

export default widgetConfigApi;
